import moment from 'moment';
import 'suggestions-jquery/dist/js/jquery.suggestions.min';
import { CoreFilters } from '@/components/filters/core-filters';

export class EventsDatesFilter extends CoreFilters {
  $filterDates;
  $list;
  listItem = '.events-item';
  $dateChanger;
  $dateChangerText;
  $loadMore;
  $hideAll;
  $forShow;
  $empty;
  $allFilters;
  $allControl;
  activeDate;
  allFilters = false;
  dateFilters = false;
  showItems = 4;
  showItemsStep = 4;

  constructor() {
    super();
    this.init();
  }

  init() {
    this.$filterDates = $('.events-filter-dates');
    this.$list = $('.events-list:not(.events-list-slider)');
    this.$allFilters = $('.events-filter-all');
    this.$loadMore = $('.events-load-more');
    this.$hideAll = $('.events-hide-all');
    this.$empty = $('.events-empty');

    if (
      (!this.$filterDates || this.$filterDates.length === 0) &&
      (!this.$allFilters || this.$allFilters.length === 0)
    ) {
      return;
    }

    if (this.$filterDates && this.$filterDates.length > 0) {
      this.$dateChanger = $('.events-date-changer');
      this.$dateChangerText = this.$dateChanger.find('.events-date-current');
      this.activeDate = moment(new Date());
      this.dateFilters = true;
      this.changeDateText();
      this.initDatesListeners();
      this.specializations = [];
      this.mySpecializations = [];
      this.nmo = false;
      this.free = false;
      this.internal = false;
      this.city = '';
    }

    if (this.$allFilters && this.$allFilters.length > 0) {
      this.$allControl = $('.events-filter-all-control');
      this.initAllListeners();
      this.allFilters = true;
    }

    this.initLoadMore();

    this.filterData();
  }

  initLoadMore() {
    this.$loadMore.on('click', () => {
      this.showItems += this.showItemsStep;
      this.showFiltered(this.$forShow, this.showItems);
      this.checkLoadMore(
        this.$forShow,
        this.$loadMore,
        this.$hideAll,
        this.$empty,
        this.showItems,
        this.showItemsStep
      );
    });

    this.$hideAll.on('click', () => {
      this.showItems = this.showItemsStep;
      this.showFiltered(this.$forShow, this.showItems);
      this.checkLoadMore(
        this.$forShow,
        this.$loadMore,
        this.$hideAll,
        this.$empty,
        this.showItems,
        this.showItemsStep
      );
    });
  }

  initDatesListeners() {
    this.$dateChanger.find('.events-date-prev').on('click', () => {
      this.changeDate('prev');
    });

    this.$dateChanger.find('.events-date-next').on('click', () => {
      this.changeDate('next');
    });
  }

  initAllListeners() {
    const $eventsFilterCity = $('.events-filter-city');

    this.$allControl.on('change', (e) => {
      const $t = $(e.currentTarget);

      if ($t.is('.events-filter-specialization')) {
        this.specializations = $t.val();
      }

      if ($t.is('.events-filter-my-specialization')) {
        if ($t.prop('checked')) {
          this.mySpecializations = $t.data('specializations');
          if (this.mySpecializations) {
            this.mySpecializations = this.mySpecializations.split(',');
          } else {
            this.mySpecializations = [];
          }
        } else {
          this.mySpecializations = [];
        }
      }

      if ($t.is('.events-filter-nmo')) {
        this.nmo = $t.prop('checked');
      }

      if ($t.is('.events-filter-free')) {
        this.free = $t.prop('checked');
      }

      if ($t.is('.events-filter-internal')) {
        this.internal = $t.prop('checked');

        if (!this.internal) {
          this.city = '';
          $eventsFilterCity.val('');
        }
      }

      if ($t.is('.events-filter-city')) {
        this.city = $t.val();
      }

      this.filterData();
    });

    $eventsFilterCity.on('keyup', (e) => {
      if (e.keyCode === 13) {
        this.city = $(e.currentTarget).val();
        this.filterData();
      }
    });

    $eventsFilterCity.suggestions({
      token: 'c656e9ed5d73c9705d1b2470522c984c89f17129',
      type: 'ADDRESS',
      bounds: 'city',
      hint: false,
      beforeRender: () => {
        $eventsFilterCity.addClass('show-suggestions');
      },
      onSelect: () => {
        $eventsFilterCity.removeClass('show-suggestions');
        this.city = $eventsFilterCity.val();
        this.filterData();
      },
      onSelectNothing: () => {
        $eventsFilterCity.removeClass('show-suggestions');
      },
    });
  }

  changeDate(direction) {
    if (direction === 'prev') {
      this.activeDate = this.activeDate.subtract(1, 'months');
    } else {
      this.activeDate = this.activeDate.add(1, 'months');
    }
    this.filterData();
    this.changeDateText();
  }

  changeDateText() {
    const currentDateText = this.activeDate.format('MMMM yyyy');
    this.$dateChangerText.text(currentDateText);
  }

  filterData() {
    const $items = this.$list.find(this.listItem);
    $items.addClass('filter-hide').removeClass('filter-for-show');
    $items.each((i, el) => {
      const $t = $(el);
      let toShow = false;
      const filters = {
        specializations: false,
        nmo: false,
        free: false,
        internal: false,
        city: false,
      };

      if (this.dateFilters) {
        const date = moment($t.data('date'));
        const min = moment(this.activeDate.startOf('month'));
        const max = moment(this.activeDate.endOf('month'));

        toShow = date.isBetween(min, max);
      }

      if (this.allFilters && toShow) {
        if (
          this.specializations.length > 0 ||
          this.mySpecializations.length > 0
        ) {
          let specializations = $t.data('specializations');
          if (specializations) specializations = specializations.split(',');
          const allSpecializations = this.specializations.concat(
            this.mySpecializations
          );

          filters.specializations = specializations.some(
            (r) => allSpecializations.indexOf(r) >= 0
          );
        } else {
          filters.specializations = true;
        }

        if (this.nmo) {
          filters.nmo = $t.data('nmo');
        } else {
          filters.nmo = true;
        }

        if (this.free) {
          filters.free = $t.data('free');
        } else {
          filters.free = true;
        }

        if (this.internal) {
          filters.internal = $t.data('internal');
        } else {
          filters.internal = true;
        }

        if (this.city.length > 0) {
          const city = $t.data('city');

          if (city) {
            filters.city = $t
              .data('city')
              .toLowerCase()
              .includes(this.city.toLowerCase());
          } else {
            filters.city = false;
          }
        } else {
          filters.city = true;
        }

        if (
          !filters.specializations ||
          !filters.nmo ||
          !filters.free ||
          !filters.internal ||
          !filters.city
        ) {
          toShow = false;
        }
      }

      if (toShow) $t.addClass('filter-for-show');
    });

    this.$forShow = this.$list.find(this.listItem + '.filter-for-show');

    this.showFiltered(this.$forShow, this.showItems);
    this.checkLoadMore(
      this.$forShow,
      this.$loadMore,
      this.$hideAll,
      this.$empty,
      this.showItems,
      this.showItemsStep
    );
  }
}
